import React, { useCallback, useEffect, useRef, useState } from "react";
import axios from "../../sagas/axios";
import ModalConfirm from "../modal/modal_confirm";

const ReviewComments = ({ reviewId, currentUser, isFormShow }) => {
  const [commentReply, setCommentReply] = useState("");
  const [comment, setComment] = useState([]);
  const [deleteCommentId, setDeleteCommentId] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const deleteCommentConfirmRef = useRef(null);
  const textareaRef = useRef(null);

  useEffect(
    () => {
      loadComment();
    },
    [reviewId, loadComment]
  );

  const handleCommentReplyBtn = useCallback(
    () => {
      if (isLoading) return;
      setIsLoading(true);
      const data = JSON.stringify({
        events_report_id: reviewId,
        comment: commentReply,
      });
      axios
        .post(`/api/circles_reviews/${reviewId}/events_reports_comments`, data)
        .then(() => {
          loadComment();
          setCommentReply("");
          setIsLoading(false);
          if (textareaRef.current) {
            textareaRef.current.style.height = 'auto';
          }
        })
        .catch(() => {
          setIsLoading(false);
        });
    },
    [isLoading, commentReply, reviewId]
  );

  const loadComment = useCallback(
    () => {
      axios
        .get(`/api/circles_reviews/${reviewId}/events_reports_comments`)
        .then((data) => {
          setComment(data.data.events_reports_comment);
        })
        .catch(() => {});
    },
    [reviewId, setComment]
  );

  const handleDeleteCommentBtn = useCallback(
    (commentId) => {
      setDeleteCommentId(commentId);
      deleteCommentConfirmRef.current.openModal();
    },
    [setDeleteCommentId, deleteCommentConfirmRef]
  );

  const deleteComment = useCallback(
    () => {
      axios
        .delete(`/api/circles_reviews/${reviewId}/events_reports_comments/${deleteCommentId}`)
        .then(() => {
          setComment((e) =>
            e.filter((comment) => comment.id !== deleteCommentId)
          );
        })
        .catch(() => {});
    },
    [deleteCommentId, reviewId]
  );

  return (
    <div>
      {comment && (
        <div className="comment-reply-box mt-4 mb-2 cp-reply" key={comment.id}>
          <div className="container mt-2">
            <div className="row pb-2 pl-3">
              <img
                src={comment.company
                  ? (comment.companies_user ? comment.companies_user.avatar_thumb : '' ) 
                  : (comment.user ? comment.user.avatar_thumb : '')}
                className="event-member-icon-small"
              />
                <p className="text-fz-14px text-black-50 mb-0 pl-3 cp-reply-name">
                  @{comment.company ? comment.companies_user 
                    ? comment.company.is_real_name_required 
                      ? comment.companies_user.view_full_name_disp : 
                        comment.companies_user.nickname
                    : "退会ユーザー"
                  : comment.user ? comment.user.tunagate_id : "退会ユーザー"}（クリエイター）
                  <span className="cp-reply-date">
                    {String(comment.created_at || "").substring(0, 10).replace(/-/g, "/")}
                  </span>
                </p>
                <p className="text-fz-14px text-black-50 mb-0">
                  {currentUser && currentUser.id == comment.user_id && (
                    <span
                      onClick={() => handleDeleteCommentBtn(comment.id)}
                      className="text-fz-14px text-black-20 pl-5 m-2 pb-0 text-right"
                    >
                      削除
                    </span>
                  )}
                </p>
            </div>
            <p className="text-fz-14px border-0 mb-0 cp-reply-text">{comment.comment}</p>
          </div>
        </div>
      )}
      {!comment && isFormShow && currentUser && !currentUser.is_banned && (
        <div className="input-group pt-3 pb-0">
          <textarea
            ref={textareaRef}
            className="form-control border-0 rounded text-fz-14px bg-gray"
            style={{ minHeight: 51, resize: 'none', overflow: 'hidden' }}
            placeholder="返信する..."
            onChange={(e) => {
              setCommentReply(e.target.value);
              const el = e.target;
              el.style.height = 'auto';
              el.style.height = `${el.scrollHeight}px`;
            }}
            value={commentReply}
          />
          <div className="input-group-append">
            <button
              className="btn text-black-50 text-fw-normal pt-1 text-fz-14px"
              onClick={handleCommentReplyBtn}
            >
              返信
            </button>
          </div>
        </div>
      )}
      <ModalConfirm
        ref={deleteCommentConfirmRef}
        title="コメントの削除"
        content="コメントを削除しますか？"
        approveFunc={deleteComment}
      />
    </div>
  )
}

export default ReviewComments;
